export const ENTITIES_CONSTANTS = {
  PLURAL: {
    DASHBOARD: 'Dashboard',
    REVIEW_SESSION: 'Reader',
    SOURCES: 'Library',
    HIGHLIGHTS: 'Highlights',
    REMINDER_LOGS: 'Reminder logs',
    IMPORT: 'Import',
    EXPORT: 'Export',
    SETTINGS: 'Settings'
  },
  SINGULAR: {
    SOURCE: 'Source of library',
    HIGHLIGHT: 'Highlight',
    REMINDER_LOG: 'Reminder log',
    SETTINGS: 'Setting'
  }

}
